import request from '@/router/axios'

export function getPage(params) {
    return request({
        url: '/chain/drivercaptaintask/projectTaskList',
        method: 'get',
        params
    })
}

